import {useState} from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import Toast from "./components/Toast";
import "./utils.css";

function App() {
  let styles = ["font-size: 12px", "color: #fffce1", "font-family: monospace", "background: #0e100f", "display: inline-block", "padding: 1rem 3rem", "border: 1px solid #fffce1", "border-radius: 4px;"].join(";");
  console.log("%cHello, I am a Backend Developer working with in Appsile. I am looking for a job. You can contact me at:shaikhaltamash411@gmail.com", styles);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  return (
    <>
      <Header />
      <Hero setToast={setToast} />
      <Projects />
      <Footer />
      <Toast message={toast.message} type={toast.type} isVisible={toast.show} onClose={() => setToast((prev) => ({...prev, show: false}))} />
    </>
  );
}

export default App;
